import { keepPreviousData, useQuery } from "@tanstack/react-query";
import axios from "../axios-orders";
import { Page, PurchaseOrderListItem, PurchaseOrderListParams } from "../types";
import { queryKeys } from "./queryKeys";

const fetchPurchaseOrders = async (
  params: PurchaseOrderListParams
): Promise<Page<PurchaseOrderListItem>> => {
  const { data } = await axios.get("/purchase-orders", { params });
  return data;
};

/** The viewer's company purchase orders (OC), server-filtered/sorted/paginated. */
export const usePurchaseOrders = (params: PurchaseOrderListParams) =>
  useQuery<Page<PurchaseOrderListItem>, Error>({
    queryKey: [queryKeys.PURCHASE_ORDERS, params],
    queryFn: () => fetchPurchaseOrders(params),
    placeholderData: keepPreviousData,
  });
